export default __webpack_public_path__ + "static/media/pin.1dfee823.png";